import { authorizedApi } from './index';

export const bridgeCardsApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    createBridgeCard: builder.mutation({
      query: ({
        currency = 'usdc',
        chain = 'solana',
      }) => ({
        url: `/bridge/cards`,
        method: 'POST',
        body: {
          currency,
          chain,
        },
      }),
    }),
    listBridgeCards: builder.query({
      query: () => ({
        url: `/bridge/cards`,
        method: 'GET',
      }),
    }),
    getBridgeCard: builder.query({
      query: (cardId) => ({
        url: `/bridge/cards/${cardId}`,
        method: 'GET',
      }),
    }),
    freezeBridgeCard: builder.mutation({
      query: (cardId) => ({
        url: `/bridge/cards/${cardId}/freeze`,
        method: 'POST',
      }),
    }),
    unfreezeBridgeCard: builder.mutation({
      query: (cardId) => ({
        url: `/bridge/cards/${cardId}/unfreeze`,
        method: 'POST',
      }),
    }),
    getBridgeCardTransactions: builder.query({
      query: ({
        cardId,
        page,
        limit,
        start_date,
        end_date,
        type,
        status
      }) => ({
        url: `/bridge/cards/${cardId}/transactions`,
        method: 'GET',
        params: {
          ...(page && { page }),
          ...(limit && { limit }),
          ...(start_date && { start_date }),
          ...(end_date && { end_date }),
          ...(type && { type }),
          ...(status && { status }),
        },
      }),
    }),
    generateCardDetailsToken: builder.mutation({
      query: (cardId) => ({
        url: `/bridge/cards/${cardId}/reveal-token`,
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useCreateBridgeCardMutation,
  useListBridgeCardsQuery,
  useGetBridgeCardQuery,
  useFreezeBridgeCardMutation,
  useUnfreezeBridgeCardMutation,
  useGetBridgeCardTransactionsQuery,
  useGenerateCardDetailsTokenMutation,
} = bridgeCardsApi;
